import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '@shared/validators/no-white-spaces.validator';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { NgxTolgeeModule } from '@tolgee/ngx';
@Component({
	selector: 'cmms-description',
	templateUrl: './cmms-description.component.html',
	styleUrls: ['./cmms-description.component.scss'],
	imports: [CommonModule, MatInputModule, ReactiveFormsModule, NgxTolgeeModule],
})
export class CmmsDescriptionComponent implements OnInit, AfterViewInit {
	/* Defining the way how textarea is shown.
	 *  If 'false' = looks like a standard textarea field;
	 *  If 'true' = looks like a text that can be edited by click;
	 */
	@Input() textModeEnabled = false;
	@Input() headerText: string = 'description';

	@Input() set description(description: string) {
		this.formControl.patchValue(description);
	}
	@Input() set isRequired(value: boolean) {
		if (value) {
			this.formControl.setValidators([Validators.required]);
		}
	}
	@Output() controlReady = new EventEmitter<FormControl>();
	@Output() descriptionBlur = new EventEmitter<{ description: string }>();

	editDescriptionMode = false;
	showMore = false;
	isVerticalOverflow = false;

	formControl = new FormControl('', [noWhitespaceValidator()]);

	@ViewChild('descriptionArea', { static: false }) descriptionArea;

	@ViewChild('descriptionText') descriptionText: ElementRef;

	constructor(private cdr: ChangeDetectorRef) {}

	ngOnInit(): void {
		this.controlReady.emit(this.formControl);
	}

	ngAfterViewInit() {
		this.delayedCheckOverflow();
	}

	editDescription() {
		this.editDescriptionMode = true;
		// set focus on element when it appear in UI.
		// Because it happening with the delay we must use callback in timeout
		setTimeout(() => this.descriptionArea.nativeElement.focus(), 0);
	}

	textareaFocusOutHandler(description: string) {
		if (this.formControl.valid) {
			this.descriptionBlur.emit({ description });
			this.editDescriptionMode = false;
			this.showMore = false;
			this.delayedCheckOverflow();
		}
	}

	toggleShowMore(): void {
		this.showMore = !this.showMore;
	}

	delayedCheckOverflow() {
		// Timeout hack is needed because element is not available at the moment
		// of call
		setTimeout(() => {
			if (this.textModeEnabled) {
				this.checkOverflow(this.descriptionText.nativeElement);
			}
		}, 0);
	}

	checkOverflow(element: HTMLElement): void {
		this.isVerticalOverflow = element.scrollHeight > element.clientHeight;
		this.cdr.detectChanges();
	}
}
